/**
 * @module app.track.poieditmobile
 */
import appBase from '../index.js';
import {MAIN_MENU_EVENT_NAME, TRACK_POI_EVENT_NAME} from "../constants";

class Controller {

  /**
   * @param {angular.Scope} $scope Angular scope.
   * @ngInject
   */
  constructor($scope) {

    /**
     * @private
     */
    this.scope_ = $scope;

    /**
     * @private
     * @type {boolean}
     */
    this.editing_ = false;

    /**
     * @private
     * @type {boolean}
     */
    this.menuClosed_ = false;

    this.scope_.$on(MAIN_MENU_EVENT_NAME.COLLAPSE, () => {
      this.menuClosed_ = true;
    });

    this.scope_.$on(MAIN_MENU_EVENT_NAME.EXPAND, () => {
      this.menuClosed_ = false;
    });

    this.scope_.$on(TRACK_POI_EVENT_NAME.SET_EDITING_STATE, (event, editing) => {
      this.editing_ = editing;
    });

  }

  /**
   * @export
   */
  finishPoiEdit() {
    this.editing_ = false;
    this.scope_.$root.$broadcast(TRACK_POI_EVENT_NAME.FINISH_DRAWING);
  }

  /**
   * @export
   */
  visible() {
    return this.menuClosed_ && this.editing_;
  }

}

const component = {
  controller: Controller,
  templateUrl: 'js/app/track/poi/edit-mobile.html'
};

export default appBase.component('appTrackPoiEditMobile', component);
